import React from "react";
import FormTitle from "../../atoms/FormTitle";
import ContentContainer from "../../atoms/ContentContainer";
import InputWrapper from "../../atoms/InputWrapper";
import ChevronRight from "../../atoms/icons/ChevronRight";
import InputItem from "../../atoms/InputItem";
import styled from "styled-components";
import InputSelect from "../../atoms/InputSelect";
const Wrapper = styled.div `
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    @media only screen and (min-width: 768px) {
        flex-direction: row;
        margin-top: 0;

        > div {
            margin-right: 20px;
        }

        > div:last-child {
            margin-right: 0;
        }
    }
`;
const StyledShortInputWrapper = styled(InputWrapper) `
    @media only screen and (min-width: 768px) {
        max-width: 170px;
        margin-top: 0;
    }
`;
const AddressInformation = ({ onChange: handleChange, onSubmit: handleSubmit, data, errors, loading, setPreviousStep, }) => (React.createElement("form", { onSubmit: handleSubmit },
    React.createElement(ContentContainer, { backButtonHandle: setPreviousStep, hasFooterActions: true, hasNextButtonIconRight: true, loading: loading, buttonFullWidth: true, nextButtonIcon: React.createElement(ChevronRight, null), nextButtonText: "Formulier verzenden" },
        React.createElement(FormTitle, null, "Adresgegevens"),
        React.createElement(Wrapper, null,
            React.createElement(InputWrapper, { maxWidth: false },
                React.createElement(InputItem, { type: "text", name: "street", label: "Straat", disabled: loading, value: data.street, error: errors.street, onChange: handleChange, fullWidth: true, required: true })),
            React.createElement(StyledShortInputWrapper, null,
                React.createElement(InputItem, { type: "text", name: "house_number", label: "Huisnummer", disabled: loading, value: data.house_number, error: errors.house_number, onChange: handleChange, fullWidth: true, required: true, maxLength: 6, pattern: "\\d+", title: "Vul hier alleen getallen in" })),
            React.createElement(StyledShortInputWrapper, null,
                React.createElement(InputItem, { type: "text", name: "house_number_addition", label: "Toevoeging", disabled: loading, value: data.house_number_addition, error: errors.house_number_addition, onChange: handleChange, maxLength: 6 }))),
        React.createElement(Wrapper, null,
            React.createElement(StyledShortInputWrapper, null,
                React.createElement(InputItem, { type: "text", name: "postal_code", label: "Postcode", disabled: loading, value: data.postal_code, error: errors.postal_code, onChange: handleChange, fullWidth: true, required: true })),
            React.createElement(InputWrapper, null,
                React.createElement(InputItem, { type: "text", name: "city", label: "Woonplaats", disabled: loading, value: data.city, error: errors.city, onChange: handleChange, fullWidth: true, required: true }))),
        React.createElement(StyledShortInputWrapper, null,
            React.createElement(InputSelect, { name: "country", value: data.country, label: "Land", options: [
                    {
                        name: "Nederland",
                        value: "NL",
                    },
                    {
                        name: "Duitsland",
                        value: "DU",
                    },
                    {
                        name: "België",
                        value: "BE",
                    },
                    {
                        name: "Polen",
                        value: "PL",
                    },
                    {
                        name: "Groot-Brittannië",
                        value: "GB",
                    },
                    {
                        name: "Frankrijk",
                        value: "FR",
                    },
                ], error: errors.country, disabled: loading, required: true, onChange: handleChange })))));
export default AddressInformation;
